import React from "react";
import {
  FaTwitter,
  FaInstagram,
  FaFacebookF,
  FaLinkedinIn,
  FaSpotify,
  FaSoundcloud,
  FaDiscord,
  FaYoutube,
  FaFacebook,
} from "react-icons/fa";
import { isMobile } from "react-device-detect";
import { Label } from "reactstrap";
import { useTranslation } from "react-i18next";
import { pressPath } from "../../home/press/pressContent";

//Social buttons actions are disabled due to social pages are not available yet, and must be activated at footer after filling the real social pages links

const FooterTwo = (props) => {
  const { t, i18n } = useTranslation();
  const gp_logo = `${process.env.PUBLIC_URL}/assets/images/gp_images/ecoshift-logo-brand-ecoshift-eco-app-movement-platform-ecoresponsible-ecopositive-ecofriendly-ecocentric.webp`;
  const logo_facebook = `${process.env.PUBLIC_URL}/assets/images/gp_images/facebook-round-color-icon.webp`;
  const logo_instagram = `${process.env.PUBLIC_URL}/assets/images/gp_images/ig-instagram-icon.webp`;
  const logo_linkedin = `${process.env.PUBLIC_URL}/assets/images/gp_images/linkedin-app-icon.webp`;
  let logoUrl = (
    <img className="logo-text-56" src={gp_logo} alt='logo' />
  );

  const SocialShare = [
  { Social: <img src={logo_facebook} width={60}/>, link: "https://www.facebook.com/people/EcoShift/61581455051131/" },
  {
    Social: <img src={logo_instagram} width={60}/>,
    link: "https://www.instagram.com/ecoshift.eco/",
  },
  {
    Social: <img src={logo_linkedin} width={60}/>,
    link: "https://www.linkedin.com/company/ecoshift-eco",
  },
    {
    Social: <div
                  style={{
                    position: "relative",
                    width: "62px",
                    height: "62px",
                  }}
                >
                  <div
                    style={{
                      position: "absolute",
                      top: "6px",
                      left: "6px",
                      width: "53px",
                      height: "53px",
                      borderRadius: "50%",
                      backgroundColor: "white",
                      zIndex: 1, // higher z-index -> on top
                    }}
                  ></div><img
                      class="eco-trustmark"
                      style={{
                      position: "absolute",
                      top: "0px",
                      left: "0px",
                      width: "62px",
                      height: "62px",
                      zIndex: 2, // higher z-index -> on top
                    }}
                      alt="ecoshift.eco"
                      src="https://trust.profiles.eco/ecoshift/eco-circle.svg?color=%231466cc&textColor=%231466cc"
                      width={70}
                    /> </div>,
    link: "https://profiles.eco/ecoshift?ref=tm",
  },

];


  return (
    <div className="footer-style-2 ptb--30 bg_color--6">
      <div className="wrapper plr--50 plr_sm--20">
        <div className="col align-items-center justify-content-between">
          <div className="inner text-center">
            <ul className="social-share rn-lg-size d-flex justify-content-center liststyle">
              <a href={props.homeLink}>
                <div className="d-flex align-items-center gap-5">
                  {logoUrl}{" "}
                  <Label
                    className="text-color-white mb-0 cursor-pointer"
                    style={{
                      fontSize: "36px",
                      fontFamily:
                        '"Gill Sans", "Gill Sans MT", Calibri, sans-serif',
                    }}
                  >
                    EcoShift
                  </Label>
                </div>
              </a>
            </ul>
          </div>

          <nav className="mainmenunav d-lg-block text-center">
            <ul className="mainmenu">
              <li>
                <a
                  href={`${process.env.PUBLIC_URL}/#home`}
                  className="text-color"
                >
                  {t("Home")}
                </a>
              </li>
              <li>
                <a
                  href={`${process.env.PUBLIC_URL}/#contact`}
                  className="text-color"
                >
                  {t("Keep me informed")}
                </a>
              </li>
              <li>
                <a
                  href={`${process.env.PUBLIC_URL}/faqs#faqs`}
                  className="text-color"
                >
                  {t("FAQs")}
                </a>
              </li>
              <li>
                <a
                  href={`${process.env.PUBLIC_URL}${pressPath}`}
                  className="text-color"
                >
                  {t("In the press")}
                </a>
              </li>
              <li>
                <a
                  href={`${process.env.PUBLIC_URL}/privacy`}
                  className="text-color"
                >
                  {t("Privacy Policy")}
                </a>
              </li>
              <li>
                <a
                  href={`${process.env.PUBLIC_URL}/terms`}
                  className="text-color"
                >
                  {t("Terms & Conditions")}
                </a>
              </li>
              <li>
                <a
                  href={`${process.env.PUBLIC_URL}/legal-notice`}
                  className="text-color"
                >
                  {t("Legal Notices")}
                </a>
              </li>
            </ul>
          </nav>
          <div className="inner text-center">
            <ul className="social-share rn-lg-size d-flex justify-content-center liststyle">
              {SocialShare.map((val, i) => (
                //Disable action until the real social page is created
                <li key={i}>
                  <a href={`${val.link}`} target="_blank">{val.Social}</a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};
export default FooterTwo;
